var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bec6c1c7-b468-46d2-8298-e691a949f324",
    "data-name": "C-wires layered OFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400.89 147.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".C-wire-channel,.ee8966e1-c84e-491a-80e7-426b6fbb4c7b{fill:none;}.C-wire-channel{stroke:#d2e4f9;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}.ee8966e1-c84e-491a-80e7-426b6fbb4c7b{stroke:#b290d1;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e8517d8a-8d71-47f2-8d1f-6605020a5391",
    "data-name": "Channel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M390.52,12.64,357.09,32.48a4,4,0,0,0-2,3.44V79.2a4,4,0,0,1-2,3.44L294,117.72a4,4,0,0,1-4.06,0L231.17,83.24a3.89,3.89,0,0,0-2-.56H14.36a4,4,0,0,0-4,4v50.43"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ad2e0861-ca2c-46b6-852b-97161706f849",
    "data-name": "OFF"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M390.52,12.64,357.09,32.48a4,4,0,0,0-2,3.44V79.2a4,4,0,0,1-2,3.44L294,117.72a4,4,0,0,1-4.06,0L231.17,83.24a3.89,3.89,0,0,0-2-.56H14.36a4,4,0,0,0-4,4v50.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ee8966e1-c84e-491a-80e7-426b6fbb4c7b",
    d: "M390.52,12.64,357.09,32.48a4,4,0,0,0-2,3.44V79.2a4,4,0,0,1-2,3.44L294,117.72a4,4,0,0,1-4.06,0L231.17,83.24a3.89,3.89,0,0,0-2-.56H14.36a4,4,0,0,0-4,4v50.43"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.1d1e8e4d.svg";
export { ForwardRef as ReactComponent };